import { cx } from '../../internal/cx.ts';
import { logoUrl, symbolUrl, type LogoLayout, type LogoSurface, type SymbolVariant } from './logo-files.ts';
import styles from './Logo.module.css';

export type LogoProps = {
  layout?: LogoLayout;
  surface?: LogoSurface;
  /** Height in pixels; the width follows. */
  height?: number;
  /** Words for screen readers; empty when the name is written next to it. */
  alt?: string;
  className?: string;
};

/** The «Pídelo Express» logo of the kit (A369). */
export function Logo({ layout = 'horizontal', surface = 'light', height = 32, alt = 'Pídelo Express', className }: LogoProps) {
  return <img src={logoUrl(layout, surface)} alt={alt} height={height} className={cx(styles.logo, className)} style={{ height }} draggable={false} />;
}

export type LogoMarkProps = { variant?: SymbolVariant; size?: number; alt?: string; className?: string };

/** The P symbol alone: the collapsed menu, the favicon, small places. */
export function LogoMark({ variant = 'color', size = 32, alt = 'Pídelo', className }: LogoMarkProps) {
  return <img src={symbolUrl(variant)} alt={alt} width={size} height={size} className={cx(styles.mark, className)} draggable={false} />;
}
